import { emptyInvestors } from '@assets';
import { Loading, Table, TokenDetails, Translator } from '@components';
import { useAdminIssuers } from '@contexts-admin';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { COLUMNS } from './TableColumns';
import Pagination from '@mui/material/Pagination';

export const Issuers = () => {
  const [showFiltersModal, setShowFiltersModal] = useState(false);
  const { getIssuers, loading, issuers, page, setPage, totalPages } = useAdminIssuers();
  const navigate = useNavigate();

  useEffect(() => {
    getIssuers(page);
  }, [page, setPage]);


  const handleChange = (event, value) => {
    setPage(value)
  };


  if (loading) {
    return <Loading />;
  }

  if (issuers?.length > 0)
    return (
      <div className="page-wrapper tokens-list">
        <div className="d-flex title">
          <p>
            <Translator path={'pages.issuers.title'} />
          </p>
          {/* // todo: Adicionar filtros
           */}

        </div>
        <Table
          props={{
            tableData: issuers,
            tableColumns: COLUMNS,
            emptyImage: emptyInvestors,
          }}
        ></Table>

        <div className='pagination-div'>
          <Pagination
            count={totalPages}
            page={page}
            variant="outlined"
            shape="rounded"
            onChange={handleChange}
          />
        </div>

      </div>
    );
};

export default Issuers;
